import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignsListHandoff } from '@/pages/workspaces/automations/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/campaigns` list URL, the older spelling of `/journeys/automations`. Flag
 * off the embedded app serves it; flag on it forwards to the migrated list.
 */
function JourneysCampaignsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCampaignsListHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/')({
  component: JourneysCampaignsIndexRoute,
});
